import type { ReactNode } from 'react';

export function Chip({
  children,
  tone = 'plain',
  title,
}: {
  children: ReactNode;
  tone?: 'plain' | 'solid' | 'warn';
  title?: string;
}) {
  return (
    <span className={`chip chip--${tone}`} title={title}>
      {children}
    </span>
  );
}

/** Mono, tabular figure with a small label. Used for byte counters. */
export function Figure({ label, value, hint }: { label: string; value: ReactNode; hint?: string }) {
  return (
    <div className="figure" title={hint}>
      <dt className="figure__label">{label}</dt>
      <dd className="figure__value">{value}</dd>
    </div>
  );
}

export function Spinner({ label }: { label?: string }) {
  return (
    <span className="spinner" role="status" aria-label={label ?? 'Working'}>
      <span className="spinner__dot" />
    </span>
  );
}
